import React, { useEffect } from 'react';
import './assets/styles/auth.scss';
import posthog from '../../analytics/posthog';
import { resetPermissionDeniedBatch } from '../../permission-system/actions/permissionDenied';
import { clearSuppressionPreferences } from '../../permission-system/modal-suppression';

export const ClearStorage = () => {
  useEffect(() => {
    function removeCookies() {
      const expired = '; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      for (const cookie of document.cookie.split(';')) {
        const name = cookie.split('=')[0].trim();
        if (!name) continue;
        document.cookie = name + '=' + expired;
        document.cookie = name + '=' + expired + '; domain=' + globalThis.location.hostname;
      }
    }
    // Reset before wiping storage — reset() reads from PostHog's own keys to
    // clean up; calling it after localStorage.clear() would be a no-op.
    posthog.reset();
    clearSuppressionPreferences();
    resetPermissionDeniedBatch();
    localStorage.clear();
    sessionStorage.clear();
    removeCookies();
    globalThis.location.href = '/';
  }, []);

  return <i>processing...</i>;
};
